import type { FilterConditionDto } from './condition';
import { BdCondition } from './condition';

export abstract class BdBooleanCondition extends BdCondition {
  protected constructor(
    id: string,
    public bool: boolean,
  ) {
    super(id);
  }

  toJSON(): FilterConditionDto {
    return {
      [this.id]: {
        flag: this.bool,
      },
    };
  }
}
